import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  googleButtonWrapper: {
    marginTop: '20px', 
    marginBottom: '20px', 
    width: '524px', 
  },
  googleButton: {
    width: '100%',
    height: '46px', 
    backgroundColor: '#fff',
    color: '#3c4043',
    border: '1px solid #dadce0',
    borderRadius: '10px', 
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Roboto, arial, sans-serif',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 12px',
    transition: 'background-color 0.2s, box-shadow 0.2s',
    '&:hover': {
      backgroundColor: '#f8f9fa',
      boxShadow: '0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)',
    },
    '&:active': {
      backgroundColor: '#e8eaed',
    },
    '&:disabled': {
      backgroundColor: '#f1f3f4',
      color: '#9aa0a6',
      border: '1px solid #dadce0',
    },
  },
  googleIcon: {
    width: '18px',
    height: '18px',
    marginRight: '12px',
  },
  buttonText: {
    fontSize: '14px',
    letterSpacing: '0.25px',
  },
}));

interface GoogleSignInButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  text?: string;
}

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  onClick,
  loading = false,
  disabled = false,
  text = 'Sign in with Google',
}) => {
  const classes = useStyles();

  return (
    <div className={classes.googleButtonWrapper}>
      <Button
        className={classes.googleButton}
        onClick={onClick}
        disabled={disabled || loading}
        variant="outlined"
      >
        {loading ? (
          <CircularProgress size={20} style={{ color: '#4285f4' }} />
        ) : (
          <>
            <svg
              className={classes.googleIcon}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
            <span className={classes.buttonText}>{text}</span>
          </>
        )}
      </Button>
    </div>
  );
};

export default GoogleSignInButton;
